import { DeliveryType, OrderStatus } from '@/resources/enums'
import type { DeliveryDate } from '@/resources/types'
import {
  MAX_ACCEPT_MINUTES,
  MAX_ACCEPT_MINUTES_TURBO,
  MAX_PICKUP_MINUTES,
  MAX_PICKUP_PENDING_MINUTES,
} from '@/pages/Orders/constants'
import {
  addTimeZone,
  millisecondsToMinutes,
  millisecondsToSeconds,
} from '@/resources/utils/global'

export const SCHEDULED_ORDER_PRIORITIZED_TIME = 60 * 60 * 1000

export const getOrderProgressBarPercent = (
  minutes: number,
  totalTime: number | undefined,
  isTurbo: boolean,
  isPickup: boolean | undefined,
  orderStatus: string | null
) => {
  let maxTime

  const isPickupPending =
    isPickup && !isTurbo && orderStatus === OrderStatus.PENDING

  const isPickupAccepted =
    isPickup && !isTurbo && orderStatus === OrderStatus.POC_ACCEPTED

  if (isPickupPending) {
    maxTime = MAX_PICKUP_PENDING_MINUTES
  } else if (isPickupAccepted) {
    maxTime = totalTime ?? MAX_PICKUP_MINUTES
  } else {
    maxTime = isTurbo
      ? (totalTime ?? MAX_ACCEPT_MINUTES_TURBO)
      : (totalTime ?? MAX_ACCEPT_MINUTES)
  }

  return 100 - (minutes * 100) / maxTime
}

export const hasOrderElapsedTimer = (
  deliveryType: DeliveryType,
  hasChopp: boolean
) =>
  (deliveryType === DeliveryType.RECEIVE ||
    deliveryType === DeliveryType.TURBO) &&
  !hasChopp

export const getScheduledOrderTotalTimeInMinutes = (
  isScheduled: boolean,
  deliveryDate?: DeliveryDate | null
) => {
  if (!isScheduled || !deliveryDate) return undefined

  return millisecondsToMinutes(
    getTimestampFromDate(deliveryDate?.endDate) -
      getTimestampFromDate(deliveryDate?.startDate)
  )
}

export const getPickupOrderTotalTimeInMinutes = (
  pickupCreateDate: number | Date,
  pickupEndDate: number | Date
) =>
  millisecondsToMinutes(
    (pickupEndDate as number) - (pickupCreateDate as number)
  )

export const getProgressBarTimeRemaining = (
  isScheduled: boolean,
  expiringTime: number,
  deliveryDate?: DeliveryDate | null
) =>
  isScheduled
    ? millisecondsToSeconds(
        getTimestampFromDate(deliveryDate?.endDate) - Date.now()
      )
    : expiringTime

export const getPickupProgressBarTimeRemaining = (
  isPickup: boolean,
  expiringTime: number,
  pickupEndDate: unknown
) =>
  isPickup
    ? millisecondsToSeconds((pickupEndDate as number) - Date.now())
    : expiringTime

export const getTimestampFromDate = (date?: string | Date | null): number =>
  date ? addTimeZone(date)?.getTime() : 0
